import script from "./AudioDragPositionGame.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioDragPositionGame.vue?vue&type=script&setup=true&lang=js"

import "./AudioDragPositionGame.vue?vue&type=style&index=0&id=06f62b9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f62b9f"]])

export default __exports__